<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>بيانات الطالب</h2>
            <!--<p>الخطوة الأولى: نبذة عن المشروع</p>-->
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="row align-items-center ">




            <div class="tab pricing-list-tab">
                <ul class="tabs">
                    <li><a href="#">البيانات</a></li>
                    <li><a href="#">حلقات التلاوة</a></li>
                    <li><a href="#">حلقات الحفظ</a></li>
                    <li><a href="#">مراجعة الحفظ</a></li>
                    <li><a href="#">التلاوة الفردية</a></li>
                    <li><a href="#">اختبارات التجويد</a></li>
                    <li><a href="#">الاختبارات التجهيزية</a></li>
                    <li><a href="#">الاختبارات الكتابية</a></li>
                    <li><a href="#">الاختبارات الشفوية</a></li>
                    <li><a href="#">الاختبارات النظرية</a></li>
                </ul>
                <div class="tab_content">
                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>الاسم الثلاثي والقبيلة</label>
                                        <input class="form-control form-control-lg" name="name" disabled
                                               #name="ngModel" [(ngModel)]="mainForm.studentName">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>الرقم المدني</label>
                                        <input class="form-control form-control-lg" name="civilID" disabled
                                               #civilID="ngModel" [(ngModel)]="mainForm.civilID">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>رقم الهاتف</label>
                                        <input class="form-control form-control-lg" name="phoneNo" disabled
                                               #phoneNo="ngModel" [(ngModel)]="mainForm.phone" (ngModelChange)="onPhoneChange($event)">
                                    </div>
                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>رقم هاتف آخر</label>
                                        <input class="form-control form-control-lg" name="otherPhoneNo" disabled
                                               #otherPhoneNo="ngModel" [(ngModel)]="mainForm.otherPhone" (ngModelChange)="onOtherPhoneChange($event)">
                                    </div>


                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>القرية</label>
                                        <input class="form-control form-control-lg" name="village" disabled
                                               #village="ngModel" [(ngModel)]="mainForm.village">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>المجموعة</label>
                                        <input class="form-control form-control-lg" name="groupName" disabled
                                               #groupName="ngModel" [(ngModel)]="mainForm.groupName">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>المدرسة</label>
                                        <input class="form-control form-control-lg" name="schoolName" disabled
                                               #schoolName="ngModel" [(ngModel)]="mainForm.schoolName">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>الصف</label>
                                        <input class="form-control form-control-lg" name="class" disabled
                                               #class="ngModel" [(ngModel)]="mainForm.class">
                                    </div>

                                    <div class="col-lg-6 col-md-6 form-group">
                                        <br />
                                        <label>الحافلة</label>
                                        <input class="form-control form-control-lg" name="busName" disabled
                                               #busName="ngModel" [(ngModel)]="mainForm.busName">
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceRecitationLecturesAttendance" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="isAttend">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحضور </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="isAttend">
                                                <mat-chip mat-sm-chip [color]="'primary'" [selected]="row.isAttend">{{row.isAttend ? 'حاضر' : 'غائب'}}</mat-chip>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacher"> {{row.teacher}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="courseTelawa">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> السورة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="courseTelawa"> {{row.courseTelawa}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="subject">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الدرس </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="subject"> {{row.subject}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="notes">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note"> {{row.note}} </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedColumnsRecitationLecturesAttendance"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsRecitationLecturesAttendance;">
                                        </mat-row>





                                    </mat-table>
                                    <mat-paginator #paginatorRecitationLecturesAttendance [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceMemorizationLecture" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName"> {{row.teacherName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="chapterName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> السورة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterName"> {{row.chapterName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="verseNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>رقم الآية </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="verseNo"> {{row.verseNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="notes">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note"> {{row.note}} </mat-cell>
                                        </ng-container>




                                        <mat-header-row *matHeaderRowDef="displayedColumnsMemorizationLecture"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsMemorizationLecture;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceMemorizationLecture !=null && dataSourceMemorizationLecture.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorMemorizationLecture [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceMemorizationReviewLecture" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName"> {{row.teacherName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="chapterName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> السورة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterName"> {{row.chapterName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="verseNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> رقم الآية </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="verseNo"> {{row.verseNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="notes">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note"> {{row.note}} </mat-cell>
                                        </ng-container>




                                        <mat-header-row *matHeaderRowDef="displayedColumnsMemorizationReviewLecture"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsMemorizationReviewLecture;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceMemorizationReviewLecture !=null && dataSourceMemorizationReviewLecture.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorMemorizationReviewLecture [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceIndividualRecitation" matSort>



                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName"> {{row.teacherName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="chapterName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> السورة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterName"> {{row.chapterName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="verseNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> رقم الآية </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="verseNo"> {{row.verseNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="notes">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsIndividualRecitation"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsIndividualRecitation;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceIndividualRecitation !=null && dataSourceIndividualRecitation.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorIndividualRecitation [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceTajweedExam" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date" [ngClass]="getClassOfTxt(row.status)"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName" [ngClass]="getClassOfTxt(row.status)"> {{row.teacherName}} </mat-cell>
                                        </ng-container>


                                        <ng-container matColumnDef="chapterNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الجزء </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterNo" [ngClass]="getClassOfTxt(row.status)"> {{row.chapterNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحالة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="status" [ngClass]="getClassOfTxt(row.status)"> {{row.status}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="note">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note" [ngClass]="getClassOfTxt(row.status)"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsTajweedExam"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsTajweedExam;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceTajweedExam !=null && dataSourceTajweedExam.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorTajweedExam [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourcePreparatoryExam" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date" [ngClass]="getClassOfTxt(row.status)"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName" [ngClass]="getClassOfTxt(row.status)"> {{row.teacherName}} </mat-cell>
                                        </ng-container>


                                        <ng-container matColumnDef="chapterNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الجزء </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterNo" [ngClass]="getClassOfTxt(row.status)"> {{row.chapterNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحالة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="status" [ngClass]="getClassOfTxt(row.status)"> {{row.status}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="note">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note" [ngClass]="getClassOfTxt(row.status)"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsPreparatoryExam"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsPreparatoryExam;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourcePreparatoryExam !=null && dataSourcePreparatoryExam.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorPreparatoryExam [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceWrittenExam" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date" [ngClass]="getClassOfTxt(row.status)"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName" [ngClass]="getClassOfTxt(row.status)"> {{row.teacherName}} </mat-cell>
                                        </ng-container>


                                        <ng-container matColumnDef="chapterNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الجزء </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="chapterNo" [ngClass]="getClassOfTxt(row.status)"> {{row.chapterNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="mark">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الدرجة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="mark" [ngClass]="getClassOfTxt(row.status)"> {{row.mark}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحالة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="status" [ngClass]="getClassOfTxt(row.status)"> {{row.status}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="note">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note" [ngClass]="getClassOfTxt(row.status)"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsWrittenExam"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsWrittenExam;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceWrittenExam !=null && dataSourceWrittenExam.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorWrittenExam [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceOralExam" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date" [ngClass]="getClassOfTxt(row.status)"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName" [ngClass]="getClassOfTxt(row.status)"> {{row.teacherName}} </mat-cell>
                                        </ng-container>


                                        <ng-container matColumnDef="examNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> رقم الاختبار </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="examNo" [ngClass]="getClassOfTxt(row.status)"> {{row.examNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="mark">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>الدرجة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="mark" [ngClass]="getClassOfTxt(row.status)"> {{row.mark}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحالة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="status" [ngClass]="getClassOfTxt(row.status)"> {{row.status}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="note">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note" [ngClass]="getClassOfTxt(row.status)"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsOralExam"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsOralExam;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceOralExam !=null && dataSourceOralExam.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorOralExam [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>


                    <div class="tabs_item">
                        <div class="row">
                            <div class="col-lg-12">

                                <div class="table-responsive">

                                    <mat-table [dataSource]="dataSourceTheoreticalExam" matSort>


                                        <ng-container matColumnDef="num">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>م. </mat-header-cell>
                                            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="date">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> التاريخ </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="date" [ngClass]="getClassOfTxt(row.status)"> {{row.date | date  : 'dd/MM/yyyy'}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="teacherName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> المعلم </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="teacherName" [ngClass]="getClassOfTxt(row.status)"> {{row.teacherName}} </mat-cell>
                                        </ng-container>


                                        <ng-container matColumnDef="examNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> رقم الاختبار </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="examNo" [ngClass]="getClassOfTxt(row.status)"> {{row.examNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="mark">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>الدرجة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="mark" [ngClass]="getClassOfTxt(row.status)"> {{row.mark}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> الحالة </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="status" [ngClass]="getClassOfTxt(row.status)"> {{row.status}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="note">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> ملاحظات </mat-header-cell>
                                            <mat-cell *matCellDef="let row" data-label="note" [ngClass]="getClassOfTxt(row.status)"> {{row.note}} </mat-cell>
                                        </ng-container>


                                        <mat-header-row *matHeaderRowDef="displayedColumnsTheoreticalExam"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumnsTheoreticalExam;">
                                        </mat-row>



                                        <ng-container matColumnDef="noData">
                                            <mat-footer-cell *matFooterCellDef colspan="6">
                                                <!--لا توجد بيانات-->
                                            </mat-footer-cell>
                                        </ng-container>
                                        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(dataSourceTheoreticalExam !=null && dataSourceTheoreticalExam.data.length==0)}">
                                        </mat-footer-row>


                                    </mat-table>
                                    <mat-paginator #paginatorTheoreticalExam [pageSizeOptions]="[50 ,100, 200, 500]"></mat-paginator>

                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>






        </div>
    </div>
</div>
